import landingPageApiFactory from '../../modules/landingPage/landingPageApi';

/* Actions */
import {
  getLandingPageInfoActionCreators,
  getCategoryLandingPageInfoActionCreators,
} from '../actions/landingPageActions';

/* Utils */
import {
  generateDefaultAsyncSaga,
  generateDefaultAsyncWatcher,
} from '../core/reduxUtils';

function landingPageSagasFactory({storefrontApiClient}) {
  const landingPageApi = landingPageApiFactory(storefrontApiClient);

  const getLandingPageInfoSagas = generateDefaultAsyncSaga(
    landingPageApi.getLandingPagesInfo,
    getLandingPageInfoActionCreators,
    payload => [
      payload.id,
      payload.platform,
      payload.params,
    ],
    {cacheKey: 'landingPageInfo', cacheStatus: true},
  );

  const getCategoryLandingPageInfoSagas = generateDefaultAsyncSaga(
    landingPageApi.getLandingPagesInfo,
    getCategoryLandingPageInfoActionCreators,
    payload => [
      payload.categoryId,
      payload.platform,
      payload.params,
    ],
    {cacheKey: 'landingPageInfo', cacheStatus: true},
  );

  const watchGetLandingPageInfo= generateDefaultAsyncWatcher(
    'GET_LANDING_PAGE_INFO',
    getLandingPageInfoSagas
  );

  const watchGetCategoryLandingPageInfo= generateDefaultAsyncWatcher(
    'GET_CATEGORY_LANDING_PAGE_INFO',
    getCategoryLandingPageInfoSagas
  );

  const landingPageSagas = [
    watchGetLandingPageInfo(),
    watchGetCategoryLandingPageInfo(),
  ];

  return landingPageSagas;
}

export default landingPageSagasFactory;







